
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexjmW9QZaIHa9epr4vsyUMK3Yy9bZoOnOmmQiXOlKTJU8Meta } from "C:/Users/csb/Documents/GitHub/RiggingCalculator/pages/index.vue?macro=true";
import { default as down_45pullohUpmxeeTygWJjBAPgZvaFTsaQtCpLLycXshOsqjwnYMeta } from "C:/Users/csb/Documents/GitHub/RiggingCalculator/pages/down-pull.vue?macro=true";
import { default as disclaimerbjZyXWM9t34jnsnDRCvQdQp5_qzQEqjilXBSq__jtzwMeta } from "C:/Users/csb/Documents/GitHub/RiggingCalculator/pages/disclaimer.vue?macro=true";
import { default as guy_45lengthuG_45SGAcVQWv4ZbkeBWRxMGe7Xj2C0RE_45NaPADmR4zFgMeta } from "C:/Users/csb/Documents/GitHub/RiggingCalculator/pages/guy-length.vue?macro=true";
import { default as guy_45tension5QgTmEUwTusQcFEvK10pBP4R8LptwtOMVX3RV6kiJFMMeta } from "C:/Users/csb/Documents/GitHub/RiggingCalculator/pages/guy-tension.vue?macro=true";
import { default as line_45tensionBRY7MVSIUI5cPDUQDetEnEBB2HTUjlTnNPvA0C9nYZ4Meta } from "C:/Users/csb/Documents/GitHub/RiggingCalculator/pages/line-tension.vue?macro=true";
import { default as block_45loadingTpaSKqs1YO4tV57o6iG8sHdZSp4_Dvj6w9i8vyp62UMMeta } from "C:/Users/csb/Documents/GitHub/RiggingCalculator/pages/block-loading.vue?macro=true";
import { default as bisect_45tensionBRAaUuvcdAnAaN3zHHH717q2pKKBWeevRsRV3SFFG8gMeta } from "C:/Users/csb/Documents/GitHub/RiggingCalculator/pages/bisect-tension.vue?macro=true";
import { default as block_45and_45tackleoNuqzm6DpDVIj0_45hJP52b76SntbPkm_bE_45PkOqXmTBgMeta } from "C:/Users/csb/Documents/GitHub/RiggingCalculator/pages/block-and-tackle.vue?macro=true";
import { default as sag_45timing_45methodeBFljf54kw3HVfttIM2Cc7ObJSEcajame4PZzaZzWm8Meta } from "C:/Users/csb/Documents/GitHub/RiggingCalculator/pages/sag-timing-method.vue?macro=true";
import { default as stringing_45tension7WDO77D_ZXTzshDnfTlWmR0ofl4oMsCJ0yjRCK0D5psMeta } from "C:/Users/csb/Documents/GitHub/RiggingCalculator/pages/stringing-tension.vue?macro=true";
import { default as conductor_45weight_45chart575rKezxrkTBUYI19JJLcWj92AaTBze4Wsp__45tFSB54Meta } from "C:/Users/csb/Documents/GitHub/RiggingCalculator/pages/conductor-weight-chart.vue?macro=true";
import { default as sling_45tension_45known_45angleQkatkfUmNzm_45pGFVULfEAvIeuk2pTt1X7aBwk_45pl628Meta } from "C:/Users/csb/Documents/GitHub/RiggingCalculator/pages/sling-tension-known-angle.vue?macro=true";
import { default as length_45of_45conductor_45on_45reelmq6Omfvyp3zPPT775_45TfsKfxBp8otXJWK9jxDRa8BrAMeta } from "C:/Users/csb/Documents/GitHub/RiggingCalculator/pages/length-of-conductor-on-reel.vue?macro=true";
import { default as sling_45tension_45unknown_45angle1beFTnfGwlcTErEqJjZr2HFbwMSLVGpeK6s_cdkb4gEMeta } from "C:/Users/csb/Documents/GitHub/RiggingCalculator/pages/sling-tension-unknown-angle.vue?macro=true";
import { default as conductor_45weight_45at_45support_45pointucJs3btMY06Opvfxl9MYgzbFiP9F8otO_GvoKj6TOigMeta } from "C:/Users/csb/Documents/GitHub/RiggingCalculator/pages/conductor-weight-at-support-point.vue?macro=true";
import { default as hot_45line_45tool_45working_45loads_45vertical_45weightkdtfSzQ95K1i0oEQ5W7Ucf6OGkMss90Zo2EY3ePaxvYMeta } from "C:/Users/csb/Documents/GitHub/RiggingCalculator/pages/hot-line-tool-working-loads-vertical-weight.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexjmW9QZaIHa9epr4vsyUMK3Yy9bZoOnOmmQiXOlKTJU8Meta || {},
    component: () => import("C:/Users/csb/Documents/GitHub/RiggingCalculator/pages/index.vue")
  },
  {
    name: "down-pull",
    path: "/down-pull",
    meta: down_45pullohUpmxeeTygWJjBAPgZvaFTsaQtCpLLycXshOsqjwnYMeta || {},
    component: () => import("C:/Users/csb/Documents/GitHub/RiggingCalculator/pages/down-pull.vue")
  },
  {
    name: "disclaimer",
    path: "/disclaimer",
    meta: disclaimerbjZyXWM9t34jnsnDRCvQdQp5_qzQEqjilXBSq__jtzwMeta || {},
    component: () => import("C:/Users/csb/Documents/GitHub/RiggingCalculator/pages/disclaimer.vue")
  },
  {
    name: "guy-length",
    path: "/guy-length",
    meta: guy_45lengthuG_45SGAcVQWv4ZbkeBWRxMGe7Xj2C0RE_45NaPADmR4zFgMeta || {},
    component: () => import("C:/Users/csb/Documents/GitHub/RiggingCalculator/pages/guy-length.vue")
  },
  {
    name: "guy-tension",
    path: "/guy-tension",
    meta: guy_45tension5QgTmEUwTusQcFEvK10pBP4R8LptwtOMVX3RV6kiJFMMeta || {},
    component: () => import("C:/Users/csb/Documents/GitHub/RiggingCalculator/pages/guy-tension.vue")
  },
  {
    name: "line-tension",
    path: "/line-tension",
    meta: line_45tensionBRY7MVSIUI5cPDUQDetEnEBB2HTUjlTnNPvA0C9nYZ4Meta || {},
    component: () => import("C:/Users/csb/Documents/GitHub/RiggingCalculator/pages/line-tension.vue")
  },
  {
    name: "block-loading",
    path: "/block-loading",
    meta: block_45loadingTpaSKqs1YO4tV57o6iG8sHdZSp4_Dvj6w9i8vyp62UMMeta || {},
    component: () => import("C:/Users/csb/Documents/GitHub/RiggingCalculator/pages/block-loading.vue")
  },
  {
    name: "bisect-tension",
    path: "/bisect-tension",
    meta: bisect_45tensionBRAaUuvcdAnAaN3zHHH717q2pKKBWeevRsRV3SFFG8gMeta || {},
    component: () => import("C:/Users/csb/Documents/GitHub/RiggingCalculator/pages/bisect-tension.vue")
  },
  {
    name: "block-and-tackle",
    path: "/block-and-tackle",
    meta: block_45and_45tackleoNuqzm6DpDVIj0_45hJP52b76SntbPkm_bE_45PkOqXmTBgMeta || {},
    component: () => import("C:/Users/csb/Documents/GitHub/RiggingCalculator/pages/block-and-tackle.vue")
  },
  {
    name: "sag-timing-method",
    path: "/sag-timing-method",
    meta: sag_45timing_45methodeBFljf54kw3HVfttIM2Cc7ObJSEcajame4PZzaZzWm8Meta || {},
    component: () => import("C:/Users/csb/Documents/GitHub/RiggingCalculator/pages/sag-timing-method.vue")
  },
  {
    name: "stringing-tension",
    path: "/stringing-tension",
    meta: stringing_45tension7WDO77D_ZXTzshDnfTlWmR0ofl4oMsCJ0yjRCK0D5psMeta || {},
    component: () => import("C:/Users/csb/Documents/GitHub/RiggingCalculator/pages/stringing-tension.vue")
  },
  {
    name: "conductor-weight-chart",
    path: "/conductor-weight-chart",
    meta: conductor_45weight_45chart575rKezxrkTBUYI19JJLcWj92AaTBze4Wsp__45tFSB54Meta || {},
    component: () => import("C:/Users/csb/Documents/GitHub/RiggingCalculator/pages/conductor-weight-chart.vue")
  },
  {
    name: "sling-tension-known-angle",
    path: "/sling-tension-known-angle",
    meta: sling_45tension_45known_45angleQkatkfUmNzm_45pGFVULfEAvIeuk2pTt1X7aBwk_45pl628Meta || {},
    component: () => import("C:/Users/csb/Documents/GitHub/RiggingCalculator/pages/sling-tension-known-angle.vue")
  },
  {
    name: "length-of-conductor-on-reel",
    path: "/length-of-conductor-on-reel",
    meta: length_45of_45conductor_45on_45reelmq6Omfvyp3zPPT775_45TfsKfxBp8otXJWK9jxDRa8BrAMeta || {},
    component: () => import("C:/Users/csb/Documents/GitHub/RiggingCalculator/pages/length-of-conductor-on-reel.vue")
  },
  {
    name: "sling-tension-unknown-angle",
    path: "/sling-tension-unknown-angle",
    meta: sling_45tension_45unknown_45angle1beFTnfGwlcTErEqJjZr2HFbwMSLVGpeK6s_cdkb4gEMeta || {},
    component: () => import("C:/Users/csb/Documents/GitHub/RiggingCalculator/pages/sling-tension-unknown-angle.vue")
  },
  {
    name: "conductor-weight-at-support-point",
    path: "/conductor-weight-at-support-point",
    meta: conductor_45weight_45at_45support_45pointucJs3btMY06Opvfxl9MYgzbFiP9F8otO_GvoKj6TOigMeta || {},
    component: () => import("C:/Users/csb/Documents/GitHub/RiggingCalculator/pages/conductor-weight-at-support-point.vue")
  },
  {
    name: "hot-line-tool-working-loads-vertical-weight",
    path: "/hot-line-tool-working-loads-vertical-weight",
    meta: hot_45line_45tool_45working_45loads_45vertical_45weightkdtfSzQ95K1i0oEQ5W7Ucf6OGkMss90Zo2EY3ePaxvYMeta || {},
    component: () => import("C:/Users/csb/Documents/GitHub/RiggingCalculator/pages/hot-line-tool-working-loads-vertical-weight.vue")
  }
]